import { render } from "./NetworkStatusBanner.vue?vue&type=template&id=29b671e8&ts=true"
import script from "./NetworkStatusBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkStatusBanner.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/NetworkStatusBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29b671e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29b671e8', __exports__)) {
    api.reload('29b671e8', __exports__)
  }
  
  module.hot.accept("./NetworkStatusBanner.vue?vue&type=template&id=29b671e8&ts=true", () => {
    api.rerender('29b671e8', render)
  })

}


export default __exports__